import moment from "moment";
import { CustomCellRendererProps } from "ag-grid-react";
import { Box, Typography, useTheme } from "@material-ui/core";
import locale, { dateFormat } from "@bonliva-crm/locale";
import { ConsultantRowData } from "../../../utils/consultant-row-data";

type Props = CustomCellRendererProps<ConsultantRowData> & {
  country: string;
  itemName: string;
  withComment?: boolean;
  expirationDateLabel?: string;
};

export function BasicQualityCheckRenderer(props: Props) {
  const theme = useTheme();

  const qc = props.data?.qualityChecks?.find(
    (x) => x.country === props.country && x.itemName === props.itemName
  );

  if (!qc) {
    return null;
  }

  const setOn = qc.setDate ? moment(qc.setDate).format(dateFormat) : "";
  const expiresOn = qc.expirationDate ? moment(qc.expirationDate).format(dateFormat) : "";

  let bgColor = undefined;

  if (qc.status === "Approved" || qc.status === "ApprovedWithComment") {
    bgColor = theme.palette.success.light;
  }

  if (qc.isPartiallyExpired) {
    bgColor = theme.palette.warning.light;
  }

  if (qc.expirationDate && new Date(qc.expirationDate) < new Date()) {
    bgColor = theme.palette.error.light;
  }

  return (
    <Box
      style={{
        backgroundColor: bgColor,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column"
      }}
      width="100%"
      height="100%"
      p={0.5}
    >
      <Typography variant="body2" display="block" style={{ padding: 0 }}>
        {locale.qualityStatuses[qc.status] || qc.status}
      </Typography>

      {(props.itemName === "Belastningsregister" ||
        props.itemName === "Belastningsregister Nationella") && (
        <Typography variant="body2" display="block">
          {locale.Type}: {qc.comment}
        </Typography>
      )}

      {setOn && (
        <Typography variant="caption" display="block">
          {locale.Date}: {setOn}
        </Typography>
      )}

      {expiresOn && (
        <Typography variant="caption" display="block">
          {props.expirationDateLabel || locale.Expires}: {expiresOn}
        </Typography>
      )}

      {props.withComment && (
        <Typography variant="caption" color="textSecondary" display="block">
          {qc.comment}
        </Typography>
      )}
    </Box>
  );
}
